export default __webpack_public_path__ + "static/media/bueno.b9216e50.png";